import {ProformaCartLabels} from '@interface/proforma-cart-labels';

class CartLabelsClass implements ProformaCartLabels {
  readonly addTo = 'AGGIUNGI_CARRELLO';
  readonly addNewTo = 'AGGIUNGI_NUOVO_CARRELLO';
  readonly label = 'CARRELLO';
  readonly delete = 'SVUOTA_CARRELLO';
  readonly deleteDesc = 'SVUOTA_CARRELLO_DESC';
  readonly detail = 'DETTAGLIO_CARRELLO';
  readonly configurationsAdded = 'CONFIGURAZIONI_CARRELLO';
  readonly search = 'CERCA_ORDINE';
  readonly emptyList = 'NO_ORDINE';
  readonly close = 'CHIUDI_CARRELLO';
  readonly recomputePrice = 'NECESSARIO_RICALCOLARE_PREZZO_B2C';
}

export const CartLabels = new CartLabelsClass();
